import { ArrowBack } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const BackButton = ({ label }) => {
  const navigate = useNavigate();
  return (
    <Button
      color="primary"
      variant="text"
      startIcon={<ArrowBack />}
      onClick={() => navigate(-1)}
      sx={{ fontWeight: "semibold", fontSize: 16, borderRadius: 2 }}
    >
      {label || ""}
    </Button>
  );
};

export default BackButton;
